export default class UserStatuses {
  static APPROVED = "approved";

  static DECLINED = "declined";

  static PENDING = "pending";
}
